export default {
  title: 'Limits & Data Collection',
  img: 'limits',
  subsections: [
    {
      title: 'Query Limits and Request Throttling',
      content: [
        {
          tag: 'p',
          content: `Upon the creation of your organization’s API Key, our services will track your usage of the BreeziPro Commercial API
          based on two consumption values:`
        },
        {
          tag: 'ul',
          content: [
            'Number of calls made to the API over a given time period (up to 500 per day)',
            `Cumulative size of the data queried throughout the billing cycle (has no bearing on billing or throttling, but is tracked for Breezi's analytics)`
          ]
        },
        {
          tag: 'p',
          content: `The default API subscription tier will allow for up to 12,000 REST calls over a period of 1 month (billing cycle).
          However, that each day will also have a maximum request limit for calling the API (400 for default tier). You may track how
          much of your data and request allottment has been consumed by following the directions for using the <b>Account Service</b> in
          the <b>API Services</b> section of this documentation.`
        }
      ]
    },
    {
      title: 'Data Collection and Access',
      content: [
        {
          tag: 'p',
          content: `To prevent data leakage and ensure a consistent and accurate stream of readings from AirPulse device to Gateway to Database,
          AirPulses collect measurements in Packets: bundles of information that can represent multiple measurement stores over a given span of
          time. Internally, the tms value represents the beginning of the measurement packet, and each subsequent dataset is measured at the
          number of seconds specified by the packet’s per (period) property, until the array of measurement values has a length equal to the ctr
          (counter) property of the packet. For this reason, lists of pointTms and packetTms are integral facets of the responses returned by the
          <b>Measurements</b> and <b>Alerts</b> Services outlined in the next section. While the services are capable of leveraging the
          Smart Interval explained in the next section to return measurement points within any range specified, it is typically recommended to
          use entries in the returned packetTms list as timestamp-related Query Parameters to ensure complete reliability from the API.`
        }
      ]
    },
    {
      title: 'Smart Interval',
      content: [
        {
          tag: 'p',
          content: `The <b>Measurements</b> Service is equipped with a Smart Interval function which will allow it to calculate the time in seconds between
          measurement packets in a requested timestamp range based on the maximum (or specified by ?limit query parameter) number of
          measurement packets for a given request. For example, if a request is made for 2 weeks of data, 121,000,000 seconds is divided by
          the maximum number of packets, 50, and will return a packet approximately every 24,200 seconds (6hr 43min). The specified
          timestamps also do not need to be exact, as the service will recursively query increasingly large periods of time to find the
          measurement packet nearest the timestamp in question. Therefore, if a packet exists at timestamp 3141592653589, but the interval
          specifies a query for a timestamp of 3141592654000, the packet will still be found and included in the response as long as no other
          packets have been recorded at a time closer to the initial timestamp.`
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/lib/apiDocTemplates/limits.js